import MasterTab from 'src/components/Layouts/MasterTab.vue';
import State from 'src/views/Pages/Dashboard/Sigatoka/State/State.vue';
import EmptyRouterView from 'src/views/Pages/GeneralViews/EmptyRouterView.vue';
import Config from 'src/views/Pages/Dashboard/Sigatoka/Config/Config.vue';

const SigatokaRouters = {
  path: 'sigatoka',
  name: 'sigatoka.sigatoka',
  component: MasterTab,
  props: { reference: 'sigatokaTabs' },
  children: [
    {
      path: 'config',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'sigatoka.sigatoka',
          component: Config,
          meta: {
            prefix_permission: 'sigatoka_evaluationleaves',
          },
        },
      ],
    },
    {
      path: 'state',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'sigatoka.sigatoka',
          component: State,
          meta: {
            prefix_permission: 'sigatoka_state',
          },
        },
      ],
    },
  ],
};

export default SigatokaRouters;
